if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"support","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(321|338|586|758)|2(056|359|484|667|712|814)|3(235|508|69|8)|4((2|37|43)2|046|443|526|744)|5(244|252|616)|88(30|8)|92(30|80|93)|6456|6904|7021|7302)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}